<div *ngIf="showSpinner" class="">
    <span class="loader"></span>
</div>